import store from '../store';

export default {
  name: 'groupsPlaceSecurity',
  isTranslator() {
    if (this.hasRole("ADMIN") || this.hasRole("TENANT_ADMIN") || this.hasRole("TRANSLATOR")) return true
    return false
  },
  hasRole(role) {
    let details = store.getters.currentUser;
    if (!details) return false;
    if (!details.roles || details.roles.length == 0) return false
    for (let r of details.roles) {
      if (r == role) return true;
    }
    return false;
  }
};
